export default __webpack_public_path__ + "locales/sr-Latn-RS/InviteDialog.json?hash=6daff03cba9bdf1f1a6b8208348c0c49";